<template>
  <div class="chain-options__variation-selector" ref="selectorRef" @click="toggleActive">
    <div class="chain-options__variation-selected">
      <span class="chain-options__variation-label">
        {{ referenceArray?.[0]?.labels || 'Length' }}
      </span>
      <span class="chain-options__selected" v-if="genarateLabel == 'Select' || genarateLabel == 'length' ||  genarateLabel == 'length-goldweight' " v-html="referenceArray?.[0]?.name"></span>
      <span v-else class="chain-options__selected" v-html="genarateLabel"></span>
    </div>

    <!-- 👇 Teleport dropdown ra body -->
    <Teleport to="body">
      <ul
        v-if="isActive"
        class="chain-options__variation-items active"
        :style="dropdownStyle"
        ref="variationItemsRef"
      >
        <li
          v-for="(item, index) in referenceArray"
          :key="item.id"
          :value="item.id"
          :data-price="item.price"
          :data-value="item.id"
          :data-attributes="JSON.stringify(item.attributes)"
          @click="handleVariationClick(item, index, $event)"
        >
          <span class="chain-options__variation-name">{{ item.name }}</span>
          <span class="chain-options__variation-price">
            + <span class="chain-options__variation-price--price" v-html="displayCustomPrice(item.prices.price.toString())"></span>
            <span v-if="item.discountAmount > 0 || parseFloat(item.prices.price) < parseFloat(item.prices.regularPrice)" class="chain-options__variation-price--regular-price" v-html="displayCustomPrice(item.prices.regularPrice.toString())"></span>
          </span>
        </li>
      </ul>
    </Teleport>

    <select class="chain-options__variation-select" v-model="selectedOptionId">
      <option>Select</option>
      <option
        v-for="(item, index) in referenceArray"
        :key="item.id"
        :value="item.id"
        :data-price="item.price"
        :data-value="item.id"
        :data-attributes="JSON.stringify(item?.attributes)"
        class="option_cs_data"
      >
        {{ item.name }}
      </option>
    </select>
  </div>
</template>


<script setup lang="ts">
import { ref, onMounted, watch, nextTick, onBeforeUnmount  } from 'vue';
import { displayCustomPrice } from '~/utils/displayPrice';
const selectorRef = ref<HTMLElement | null>(null);
const dropdownStyle = ref({})
const props = defineProps<{
  referenceArray: Array<{
    id: number | string;
    name: string;
    price: number;
    prices: any;
    labels?: string;
    discountAmount: number;
    attributes?: any;
  }>;
  genarateLabel: string;
  isActive: boolean;
  reset: number;
}>();

const emit = defineEmits(['updateLabel', 'updatePrice']);
const selectedOptionId = ref<string | number>('Select');
const isActive = ref(props.isActive);
const selectedIndex = ref<number | null>(null);

const updatePositionOnScroll = () => {
  if (isActive.value) updateDropdownPosition();
};

const toggleActive = () => {
  const activeElement = document.querySelector('.list_chain-options__select-chain.active');
  isActive.value = !isActive.value;
  if (isActive.value) {
    setTimeout(() => {
      if (activeElement) {
        activeElement.classList.add('overflow-hidden');
      }
      check_scroll.value = false;
      updateDropdownPosition()
    }, 0)
  }
  else{
    if (activeElement) {
      activeElement.classList.remove('overflow-hidden');
    }
  }
};

const check_scroll = ref(false);
const rect_onX = ref<number | null>(null);
const rect_onY = ref<number | null>(null);
const lastScrollY = ref<number>(0);
const lastTop = ref<number>(0);
const lastLeft = ref<number>(0);

const updateDropdownPosition = () => {
  requestAnimationFrame(() => {
    const selector = selectorRef.value;
    if (!selector) return;

    const rect = selector.getBoundingClientRect();
    const scrollTop = window.scrollY;
    const scrollLeft = window.scrollX;

    if (!check_scroll.value) {
      rect_onY.value = rect.bottom + scrollTop;
      rect_onX.value = rect.left + scrollLeft;
      check_scroll.value = true;
    }

    let top: number;
    let left: number;

    if (scrollTop < 10 && rect_onX.value !== null && rect_onY.value !== null) {
      top = rect_onY.value;
      left = rect_onX.value;
    } else {
      top = rect.bottom + scrollTop;
      left = rect.left + scrollLeft;
    }

    if (top !== lastTop.value || left !== lastLeft.value) {
      dropdownStyle.value = {
        position: 'absolute',
        top: `${top}px`,
        left: `${left}px`,
        zIndex: 90,
        background: '#fff',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        borderRadius: '4px',
        minWidth: `${rect.width}px`,
      };

      lastTop.value = top;
      lastLeft.value = left;
    }

    lastScrollY.value = scrollTop;
  });
};



watch(() => props.reset, () => {
  if (props.referenceArray.length > 0) {
    const firstItem = props.referenceArray[0];
    selectedIndex.value = 0;
    selectedOptionId.value = firstItem.id;
    emit('updateLabel', firstItem.name);
    emit('updatePrice', firstItem.prices, 0);
  } else {
    selectedIndex.value = null;
    selectedOptionId.value = 'Select';
    emit('updateLabel', 'Select');
  }
  isActive.value = false;
});

const handleVariationClick = (
  item: { id: number | string; name: string; price: number; prices: any; },
  index: number,
  event: Event
) => {
  const activeElement = document.querySelector('.list_chain-options__select-chain.active');
  if (activeElement) {
    activeElement.classList.remove('overflow-hidden');
  }
  
  if (selectedIndex.value === index){
    isActive.value = false;
    return;
  } 

  selectedIndex.value = index;
  selectedOptionId.value = item.id;

  emit('updatePrice', item.prices, index);
  emit('updateLabel', item.name);

  nextTick(() => {
  const selectEl = document.querySelector('.chain-options__variation-select') as HTMLSelectElement | null;

  if (selectEl) {
      const options = selectEl.querySelectorAll('option.option_cs_data') as NodeListOf<HTMLOptionElement>;

      options.forEach(option => {
      if (option.value == item.id.toString()) {
          option.classList.add('active');
      } else {
          option.classList.remove('active');
      }
      });
  }
  });
  isActive.value = false;
  
};

const variationItemsRef = ref<HTMLElement | null>(null);
const handleClickOutside = (event: MouseEvent) => {
  const target = event.target as Node;
  if (selectorRef.value &&
  !selectorRef.value.contains(target) &&
  variationItemsRef.value &&
  !variationItemsRef.value.contains(target)
) {
    const activeElement = document.querySelector('.list_chain-options__select-chain.active');
    if (activeElement) {
      activeElement.classList.remove('overflow-hidden');
    }
    isActive.value = false;
  }
};

onMounted(() => {
  if (props.referenceArray.length > 0) {
    const firstItem = props.referenceArray[0];
    selectedOptionId.value = firstItem.id;
    selectedIndex.value = 0;
    emit('updatePrice', firstItem.prices, 0);
    emit('updateLabel', firstItem.name);
  }
  document.addEventListener('click', handleClickOutside);
  window.addEventListener('scroll', updatePositionOnScroll, true); // true: capture all scrolls
  window.addEventListener('resize', updatePositionOnScroll);
});
onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside);
  window.removeEventListener('scroll', updatePositionOnScroll, true);
  window.removeEventListener('resize', updatePositionOnScroll);
});
</script>

<style lang="scss">
    .chain-options__variation-items {
      &.active {
        padding-left: 0;
        padding-top: 10px;
        margin-top: 10px;
        max-height: 200px;
        overflow-x: hidden;
        overflow-y: auto;
        &::-webkit-scrollbar {
          width: 5px; 
        }

        &::-webkit-scrollbar-track {
          background: #f1f1f1;
        }

        &::-webkit-scrollbar-thumb {
          background: #bebebe;
          border-radius: 4px;
        }
        li {
          align-items: center;
          background-color: #fff;
          color: #212529;
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          margin-bottom: 5px;
          padding: 6px 16px;
          text-align: right;
          .chain-options__variation-name {
            color: #212529;
            font-size: 12px;
          }
          .chain-options__variation-price {
            color: #212529;
            font-size: 12px;
          }
          .chain-options__variation-price--price {
            color: #212529;
          }
          .chain-options__variation-price--regular-price {
            color: #9d9d9d;
            margin-left: 7px;
            position: relative;
            &::before {
              background-color: #9d9d9d;
              content: "";
              height: 1px;
              left: 0;
              position: absolute;
              top: 50%;
              width: 100%;
            }
          }
        }
      }
    }
</style>